// src/pages/admin/Distribute.js
import React from "react";
import FormWrapper from "../../forms/shared/FormWrapper";

// ฟอร์ม “เชิญประชุมอนุมัติจ่ายเงินปันผล”
import DistributeForm from "../../forms/business/Distribute/Distribute";

function DistributePage() {
  return (
    <FormWrapper
      title="จ่ายเงินปันผล"
      FormComponent={DistributeForm}
      formKey="Distribute"
    />
  );
}

export default DistributePage;
